import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { Job } from '../../models/jobs/jobs.model';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';

@Component({
  selector: 'swb-job-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None
})
export class JobDetailComponent extends FormDetailBase<Job> implements OnInit {

  public url = 'jobs';
  protected _redirect = './career';

  public entity = new Job({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název pozice',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textbox({
        key: 'subtitle',
        label: 'Podnázev',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textbox({
        key: 'location',
        label: 'Pracoviště',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Popis',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'job-detail'
      }),
      new Textbox({
        key: 'sorter',
        label: 'Pořadí',
        type: 'number'
      })
    ];
  }

  public formEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }


}
